"use strict";

/* globals $, app, socket */

(function() {
	function updateTagsTopic(tid) {
		if(tid) {
			socket.emit('plugins.GTHashtag.getTopicTags', {tid: tid}, function(err, data_tags) {
				if (data_tags && tagsUpdatedGT(data_tags)) {
					app.parseAndTranslate('partials/post_bar', 'tags', {tags: data_tags}, function(html) {
						var tags = $('.tags');
						tags.fadeOut(250, function() {
							tags.html(html).fadeIn(250);
						});
					});
				}
			});
		}
	}

	function updateTagsTopicNewPost(data) {
		if(data && data.posts && data.posts[0] && data.posts[0].tid) {
			updateTagsTopic(data.posts[0].tid);
		}
	}

	function updateTagsTopicEditPost(data) {
		if(data && data.post && data.post.tid) {
			updateTagsTopic(data.post.tid);
		}
	}

	// same function as event.js:128
	function tagsUpdatedGT(tags) {		
		if (tags.length !== $('.tags').first().children().length) {
			return true;
		}

		for (var i=0; i<tags.length; ++i) {
			if (!$('.tags .tag-item[data-tag="' + tags[i].value + '"]').length) {
				return true;
			}
		}
		return false;
	}

	socket.on('event:new_post', updateTagsTopicNewPost);
	socket.on('event:post_edited', updateTagsTopicEditPost);
}());